import { render } from "./HeartRateRanking.vue?vue&type=template&id=21cd4234&scoped=true"
import script from "./HeartRateRanking.vue?vue&type=script&lang=js"
export * from "./HeartRateRanking.vue?vue&type=script&lang=js"

import "./HeartRateRanking.vue?vue&type=style&index=0&id=21cd4234&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cd4234"]])

export default __exports__